import API from 'api';
import * as C from './constants';
import receiveNetworkException from './network';
import error from './error';

export const signIn = (params) => (dispatch) => {
  dispatch({ type: C.SIGN_IN });

  return API.session.signIn(params)
    .then(({ body: data }) => {
      localStorage.setItem('auth', JSON.stringify(data));
      return dispatch({ type: C.SIGN_IN_SUCCESS, data });
    })
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      if (e.response.data.error && e.response.data.error_description) {
        dispatch(error(C.SIGN_IN_ERROR, {
          message: 'Failed to login',
          description: e.response.data.error_description,
        }));
      } else {
        dispatch(error(C.SIGN_IN_ERROR, {
          message: 'Failed to login',
          description: 'Please check your email and/or password.',
        }));
      }
      
      throw (e);
    });
};

export const refreshToken = (token) => (dispatch) => {
  dispatch({ type: C.REFRESH_TOKEN });
  const body = {
    grant_type: 'refresh_token',
    refresh_token: token,
  };

  return API.session.signIn(body)
    .then(({ body: data }) => {
      localStorage.setItem('auth', JSON.stringify(data));
      return dispatch({ type: C.REFRESH_TOKEN_SUCCESS, data });
    })
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      dispatch(error(C.REFRESH_TOKEN_ERROR, {
        message: 'Your session has expired',
        description: 'Please login again.',
      }));
      throw (e);
    });
};

export const signOut = (token) => (dispatch) => {
  localStorage.clear();
  dispatch({ type: C.SIGN_OUT });

  return API.session.signOut(token)
    .then(() => dispatch({ type: C.SIGN_OUT_SUCCESS }));
};
